<!-- Spinner while Okta info is being loaded -->
<div *ngIf="!oktaService.fullName && !isViewer" class="pd-loader" >
    <hc-progress-spinner color="purple" [diameter]="75"></hc-progress-spinner>
</div>

<div class="fixed-navbar-container" *ngIf="oktaService.fullName && !isViewer">
    <hc-navbar 
        brandIcon="https://cashmere.healthcatalyst.net/assets/TriFlame.svg"
        [appIcon]="isProd ? './assets/ProductsLogo.svg' : './assets/ProductsLogoDev.svg'"
        homeUri="/"
        [fixedTop]="true"
    >
        <hc-navbar-link uri="/catalog" linkText="Catalog"></hc-navbar-link>
        <hc-navbar-link uri="/sources" linkText="Sources"></hc-navbar-link>
        <hc-navbar-link uri="/definitions" linkText="Definitions"></hc-navbar-link>
        <hc-navbar-link uri="/downloads" linkText="Downloads"></hc-navbar-link>
        <hc-navbar-link uri="/api" linkText="API"></hc-navbar-link>
        <hc-navbar-link uri="/admin" linkText="Admin" *ngIf="oktaService.admin"></hc-navbar-link>
        
        <hc-icon class="hc-navbar-icon" fontSet="fa" fontIcon="fa-question-circle-o" [hcPop]="options" tabindex="0"></hc-icon>
        <span class="hc-navbar-vertical-separator"></span>
        <div class="hc-navbar-username" *ngIf="user" [hcPop]="user" tabindex="0">
            <span>{{ oktaService.fullName }}</span>
            <hc-icon fontSet="fa" fontIcon="fa-angle-down"></hc-icon>
        </div>

        <hc-navbar-mobile-menu #mobileMenu>
            <hc-list>
                <hc-list-item routerLink="/catalog" routerLinkActive="active-link"><span hcListLine>Catalog</span></hc-list-item>
                <hc-list-item routerLink="/sources" routerLinkActive="active-link"><span hcListLine>Sources</span></hc-list-item>
            </hc-list>
            <hr>
            <hc-list>
                <hc-list-item routerLink="/definitions" routerLinkActive="active-link"><span hcListLine>Definitions</span></hc-list-item>
                <hc-list-item routerLink="/downloads" routerLinkActive="active-link"><span hcListLine>Downloads</span></hc-list-item>
            </hc-list>
            <hr>
            <hc-list class="pd-mobile-menu-list">
                <hc-list-item>
                    <a class="pd-app-menu-anchor" href="https://docs.healthcatalyst.com" target="_blank" hcListLine>
                        Product Docs
                    </a>
                </hc-list-item>
                <hc-list-item>
                    <a class="pd-app-menu-anchor" href="https://community.healthcatalyst.com" target="_blank" hcListLine>
                        Health Catalyst Community
                    </a>
                </hc-list-item>
                <hc-list-item>
                    <a class="pd-app-menu-anchor" href="https://healthcatalyst.com" target="_blank" hcListLine>
                        Health Catalyst Website
                    </a>
                </hc-list-item>
                <hc-list-item>
                    <a class="pd-app-menu-anchor" href="https://healthcatalyst.atlassian.net/servicedesk/customer/portals" target="_blank" hcListLine>
                        Report an Issue
                    </a>
                </hc-list-item>
            </hc-list>
            <hr>
            <hc-list>
                <hc-list-item (click)="logout()"><span hcListLine>Log out of this app</span></hc-list-item>
            </hc-list>
        </hc-navbar-mobile-menu>
    </hc-navbar>
</div>

<div [hidden]="!oktaService.fullName && !isViewer">
    <router-outlet></router-outlet>
</div>

<hc-pop #options [autoCloseOnContentClick]="true" [showArrow]="false" horizontalAlign="end">
    <div hcMenu>
        <a hcMenuItem href="https://docs.healthcatalyst.com" target="_blank">
            <hc-icon hcMenuIcon fontSet="fa" fontIcon="fa-book"></hc-icon>
            <span hcMenuText>Product Docs</span>
        </a>
        <a hcMenuItem href="https://community.healthcatalyst.com" target="_blank">
            <hc-icon hcMenuIcon fontSet="fa" fontIcon="fa-users"></hc-icon>
            <span hcMenuText>Health Catalyst Community</span>
        </a>
        <a hcMenuItem href="https://healthcatalyst.com" target="_blank">
            <hc-icon hcMenuIcon fontSet="hc-icons" fontIcon="hci-catalyst-logo"></hc-icon>
            <span hcMenuText>Health Catalyst Website</span>
        </a>
        <a hcMenuItem href="https://healthcatalyst.atlassian.net/servicedesk/customer/portals" target="_blank">
            <hc-icon hcMenuIcon fontSet="fa" fontIcon="fa-bug"></hc-icon>
            <span hcMenuText>Report an Issue</span>
        </a>
        <div hcMenuItem hcDivider></div>
        <button hcMenuItem (click)="about(aboutModal)">
            <hc-icon hcMenuIcon fontSet="fa" fontIcon="fa-info-circle"></hc-icon>
            <span hcMenuText>About</span>
        </button>
    </div>
</hc-pop>

<hc-pop #user [autoCloseOnContentClick]="true" [showArrow]="false" horizontalAlign="end">
    <div hcMenu>
        <button hcMenuItem (click)="impersonateModeOn()" *ngIf="oktaService.admin">
            <hc-icon hcMenuIcon fontSet="fa" fontIcon="fa-eye"></hc-icon>
            <span hcMenuText>Impersonate standard user</span>
        </button>
        <button hcMenuItem (click)="impersonateModeOff()" *ngIf="oktaService.impersonateMode">
            <hc-icon hcMenuIcon fontSet="fa" fontIcon="fa-eye-slash"></hc-icon>
            <span hcMenuText>Return to admin user</span>
        </button>
        <button hcMenuItem (click)="logout()">
            <hc-icon hcMenuIcon fontSet="hc-icons" fontIcon="hci-sign-out"></hc-icon>
            <span hcMenuText>Log out of this app</span>
        </button>
    </div>
</hc-pop>

<ng-template #aboutModal let-dismiss="dismiss">
    <hc-modal class="product-catalog-about-modal">
        <div class="about-modal-container about-modal-content">
            <div class="about-header">
                <img src="https://cashmere.healthcatalyst.net/assets/HealthCatalyst_Horizontal.svg" class="about-logo" alt="" />
                <div class="about-app">
                    <div class="about-icon">
                        <img src="https://cashmere.healthcatalyst.net/assets/product-icons/HCCommunity.svg" alt="" />
                    </div>
                    <div class="about-name">
                        <img src="./assets/ProductsLogo.svg" alt="" />
                        <div class="about-version">
                            Release {{appVersion}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="about-modal-content-container">
                <div class="about-reference">
                    <h3>Welcome to the Technology and Services Catalog!</h3>
    
                    <h4>What you'll find:</h4>
                    <article>
                        <ul>
                            <li>A complete, searchable list of our technology and services (Catalog tab)</li>
                            <li>Polished, client-ready data sheets, updated with the new branding and simplified, external-facing content (Catalog tab: hover over any line, and buttons appear at right)</li>
                            <li>List of sources we've implemented, as well as data sets and registries we offer to clients (Sources tab)</li>
                            <li>Technology and Services Catalog (updated quarterly) includes our legal definitions of our products to use in sales contracts (Downloads tab)</li>
                            <li>Contractual definitions of terms used in the Technology and Services Catalog (Definitions tab)</li>
                        </ul>
                    </article>
    
                    <h4>Access:</h4>
                    <article>
                        <ul>
                            <li>Team members can access all tabs on this site with their Okta login.</li>
                            <li>Clients and prospects can access direct links to the data sheets and the Technology and Services Catalog, as well as the Change Log (via a link in the Technology and Services Catalog).</li>
                        </ul>
                    </article>
    
                    <h4>Feedback:</h4>
                    <article>
                        <ul>
                            <li>Have comments or questions? Send to <a href="mailto:contentteam@healthcatalyst.com">contentteam&#64;healthcatalyst.com</a></li>
                        </ul>
                    </article>
                </div>
                <div class="about-footer">
                    Copyright {{today.getFullYear()}} <a href="https://www.healthcatalyst.com/">Health Catalyst</a>. All rights reserved
                    <br>
                    <a href="https://www.healthcatalyst.com/terms-conditions/">Terms and Conditions</a>  |  <a href="https://www.healthcatalyst.com/privacy-policy/">Privacy Policy</a>
                </div>
            </div>
        </div>
        <hr class="about-divider">
        <div class="about-close-container">
            <button hc-button class="about-close" (click)="dismiss()">Close</button>
        </div>
    </hc-modal>
</ng-template>